var exports = {
  "uL": "PopoutTitlebar.module__titlebar___OVBSWU",
  "pY": "PopoutTitlebar.module__titlebarMac___OVBSWU",
  "DD": "PopoutTitlebar.module__title___OVBSWU",
  "o1": "PopoutTitlebar.module__actions___OVBSWU",
  "bR": "PopoutTitlebar.module__actionButtonActive___OVBSWU",
};

module.exports = exports;
